import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const TermsAndConditionsContentStyle = styled.div`
	display: flex;
	flex-direction: column;

	.title {
		margin-bottom: 36px;
	}

	.row {
		display: flex;
		flex-direction: column;
		gap: 8px;

		${breakPoints({
			'768': `
				flex-direction: row;
			`,
		})}

		em {
			font-style: italic;
		}

		blockquote {
			border-left: 5px solid #ccc;
			margin: 1.5em 10px;
			padding: 0.5em 10px;
		}

		& > p {
			width: 100%;
			flex: 1;
			word-break: break-word;

			&:not(:first-of-type) {
				border-bottom: 1px solid #000000;
			}

			&:first-of-type {
				padding-top: 12px;
				max-width: 360px;
				${breakPoints({
					'768': `
						padding-bottom: 12px;
					`,
				})}
			}

			&:last-of-type {
				padding-bottom: 12px;
				${breakPoints({
					'768': `
						padding-top: 12px;
					`,
				})}
			}

			&.activate-list-view {
				li {
					list-style-type: disc;
					list-style-position: inside;
				}
			}

			${breakPoints({
				'768': `
					&:first-of-type {
						border-bottom: 1px solid #000000;
					}
				`,
			})}
		}
	}

	.btn-container {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 4px;
		margin-top: 36px;
		button {
			&[disabled] {
				background: rgb(179, 179, 179);
			}
		}
	}
`;
